import { createAction } from '@reduxjs/toolkit';
import { GoogleBulkParams } from './model';

export const linkRequested = createAction<GoogleBulkParams>('al/googleBulk/linkRequested');

export const setInProgress = createAction<{ hash: string; inProgress: boolean }>(
  'al/googleBulk/setInProgress',
);

export const setProgressValue = createAction<{ hash: string; value: number }>(
  'al/googleBulk/setProgressValue',
);

export const linkCreated = createAction<{ hash: string; link: string }>(
  'al/googleBulk/linkCreated',
);
